// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EntityLayerId } from '../tbs/entity-layer-id.js';
import { EntityTypeId } from '../tbs/entity-type-id.js';
import { MoveTypeId } from '../tbs/move-type-id.js';
import { RoadKind } from '../tbs/road-kind.js';
import { Weapon, WeaponT } from '../tbs/weapon.js';


export class Entity implements flatbuffers.IUnpackableObject<EntityT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):Entity {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEntity(bb:flatbuffers.ByteBuffer, obj?:Entity):Entity {
  return (obj || new Entity()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEntity(bb:flatbuffers.ByteBuffer, obj?:Entity):Entity {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Entity()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

etypeId():EntityTypeId {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EntityTypeId.Sea;
}

layerId():EntityLayerId {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : EntityLayerId.TerrainL1;
}

id():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

x():number {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

y():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

heading():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

hp():number {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

fuel():number {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

vision():number {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

armor():number {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

mobility():number {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

mtypeId():MoveTypeId {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : MoveTypeId.None;
}

builtThisTurn():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

attackedThisTurn():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 32);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

waitedThisTurn():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 34);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

destroyed():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 36);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

annexed():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 38);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

hasError():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 40);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

cargo(index: number):number|null {
  const offset = this.bb!.__offset(this.bb_pos, 42);
  return offset ? this.bb!.readUint32(this.bb!.__vector(this.bb_pos + offset) + index * 4) : 0;
}

cargoLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 42);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

cargoArray():Uint32Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 42);
  return offset ? new Uint32Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
}

taxiId():number {
  const offset = this.bb!.__offset(this.bb_pos, 44);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

weapons(index: number, obj?:Weapon):Weapon|null {
  const offset = this.bb!.__offset(this.bb_pos, 46);
  return offset ? (obj || new Weapon()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

weaponsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 46);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

floorE():number {
  const offset = this.bb!.__offset(this.bb_pos, 48);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

waterE():number {
  const offset = this.bb!.__offset(this.bb_pos, 50);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

road():RoadKind {
  const offset = this.bb!.__offset(this.bb_pos, 52);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : RoadKind.None;
}

ap():number {
  const offset = this.bb!.__offset(this.bb_pos, 54);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

apEntId():number {
  const offset = this.bb!.__offset(this.bb_pos, 56);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

static startEntity(builder:flatbuffers.Builder) {
  builder.startObject(27);
}

static addEtypeId(builder:flatbuffers.Builder, etypeId:EntityTypeId) {
  builder.addFieldInt16(0, etypeId, EntityTypeId.Sea);
}

static addLayerId(builder:flatbuffers.Builder, layerId:EntityLayerId) {
  builder.addFieldInt8(1, layerId, EntityLayerId.TerrainL1);
}

static addId(builder:flatbuffers.Builder, id:number) {
  builder.addFieldInt32(2, id, 0);
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt32(3, playerId, -1);
}

static addX(builder:flatbuffers.Builder, x:number) {
  builder.addFieldInt32(4, x, 0);
}

static addY(builder:flatbuffers.Builder, y:number) {
  builder.addFieldInt32(5, y, 0);
}

static addHeading(builder:flatbuffers.Builder, heading:number) {
  builder.addFieldInt32(6, heading, 0);
}

static addHp(builder:flatbuffers.Builder, hp:number) {
  builder.addFieldInt32(7, hp, -1);
}

static addFuel(builder:flatbuffers.Builder, fuel:number) {
  builder.addFieldInt32(8, fuel, -1);
}

static addVision(builder:flatbuffers.Builder, vision:number) {
  builder.addFieldInt32(9, vision, -1);
}

static addArmor(builder:flatbuffers.Builder, armor:number) {
  builder.addFieldInt32(10, armor, -1);
}

static addMobility(builder:flatbuffers.Builder, mobility:number) {
  builder.addFieldInt32(11, mobility, -1);
}

static addMtypeId(builder:flatbuffers.Builder, mtypeId:MoveTypeId) {
  builder.addFieldInt8(12, mtypeId, MoveTypeId.None);
}

static addBuiltThisTurn(builder:flatbuffers.Builder, builtThisTurn:boolean) {
  builder.addFieldInt8(13, +builtThisTurn, +false);
}

static addAttackedThisTurn(builder:flatbuffers.Builder, attackedThisTurn:boolean) {
  builder.addFieldInt8(14, +attackedThisTurn, +false);
}

static addWaitedThisTurn(builder:flatbuffers.Builder, waitedThisTurn:boolean) {
  builder.addFieldInt8(15, +waitedThisTurn, +false);
}

static addDestroyed(builder:flatbuffers.Builder, destroyed:boolean) {
  builder.addFieldInt8(16, +destroyed, +false);
}

static addAnnexed(builder:flatbuffers.Builder, annexed:boolean) {
  builder.addFieldInt8(17, +annexed, +false);
}

static addHasError(builder:flatbuffers.Builder, hasError:boolean) {
  builder.addFieldInt8(18, +hasError, +false);
}

static addCargo(builder:flatbuffers.Builder, cargoOffset:flatbuffers.Offset) {
  builder.addFieldOffset(19, cargoOffset, 0);
}

static createCargoVector(builder:flatbuffers.Builder, data:number[]|Uint32Array):flatbuffers.Offset;
/**
 * @deprecated This Uint8Array overload will be removed in the future.
 */
static createCargoVector(builder:flatbuffers.Builder, data:number[]|Uint8Array):flatbuffers.Offset;
static createCargoVector(builder:flatbuffers.Builder, data:number[]|Uint32Array|Uint8Array):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addInt32(data[i]!);
  }
  return builder.endVector();
}

static startCargoVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addTaxiId(builder:flatbuffers.Builder, taxiId:number) {
  builder.addFieldInt32(20, taxiId, -1);
}

static addWeapons(builder:flatbuffers.Builder, weaponsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(21, weaponsOffset, 0);
}

static createWeaponsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startWeaponsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addFloorE(builder:flatbuffers.Builder, floorE:number) {
  builder.addFieldInt32(22, floorE, -1);
}

static addWaterE(builder:flatbuffers.Builder, waterE:number) {
  builder.addFieldInt32(23, waterE, -1);
}

static addRoad(builder:flatbuffers.Builder, road:RoadKind) {
  builder.addFieldInt8(24, road, RoadKind.None);
}

static addAp(builder:flatbuffers.Builder, ap:number) {
  builder.addFieldInt32(25, ap, -1);
}

static addApEntId(builder:flatbuffers.Builder, apEntId:number) {
  builder.addFieldInt32(26, apEntId, -1);
}

static endEntity(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEntity(builder:flatbuffers.Builder, etypeId:EntityTypeId, layerId:EntityLayerId, id:number, playerId:number, x:number, y:number, heading:number, hp:number, fuel:number, vision:number, armor:number, mobility:number, mtypeId:MoveTypeId, builtThisTurn:boolean, attackedThisTurn:boolean, waitedThisTurn:boolean, destroyed:boolean, annexed:boolean, hasError:boolean, cargoOffset:flatbuffers.Offset, taxiId:number, weaponsOffset:flatbuffers.Offset, floorE:number, waterE:number, road:RoadKind, ap:number, apEntId:number):flatbuffers.Offset {
  Entity.startEntity(builder);
  Entity.addEtypeId(builder, etypeId);
  Entity.addLayerId(builder, layerId);
  Entity.addId(builder, id);
  Entity.addPlayerId(builder, playerId);
  Entity.addX(builder, x);
  Entity.addY(builder, y);
  Entity.addHeading(builder, heading);
  Entity.addHp(builder, hp);
  Entity.addFuel(builder, fuel);
  Entity.addVision(builder, vision);
  Entity.addArmor(builder, armor);
  Entity.addMobility(builder, mobility);
  Entity.addMtypeId(builder, mtypeId);
  Entity.addBuiltThisTurn(builder, builtThisTurn);
  Entity.addAttackedThisTurn(builder, attackedThisTurn);
  Entity.addWaitedThisTurn(builder, waitedThisTurn);
  Entity.addDestroyed(builder, destroyed);
  Entity.addAnnexed(builder, annexed);
  Entity.addHasError(builder, hasError);
  Entity.addCargo(builder, cargoOffset);
  Entity.addTaxiId(builder, taxiId);
  Entity.addWeapons(builder, weaponsOffset);
  Entity.addFloorE(builder, floorE);
  Entity.addWaterE(builder, waterE);
  Entity.addRoad(builder, road);
  Entity.addAp(builder, ap);
  Entity.addApEntId(builder, apEntId);
  return Entity.endEntity(builder);
}

unpack(): EntityT {
  return new EntityT(
    this.etypeId(),
    this.layerId(),
    this.id(),
    this.playerId(),
    this.x(),
    this.y(),
    this.heading(),
    this.hp(),
    this.fuel(),
    this.vision(),
    this.armor(),
    this.mobility(),
    this.mtypeId(),
    this.builtThisTurn(),
    this.attackedThisTurn(),
    this.waitedThisTurn(),
    this.destroyed(),
    this.annexed(),
    this.hasError(),
    this.bb!.createScalarList<number>(this.cargo.bind(this), this.cargoLength()),
    this.taxiId(),
    this.bb!.createObjList<Weapon, WeaponT>(this.weapons.bind(this), this.weaponsLength()),
    this.floorE(),
    this.waterE(),
    this.road(),
    this.ap(),
    this.apEntId()
  );
}


unpackTo(_o: EntityT): void {
  _o.etypeId = this.etypeId();
  _o.layerId = this.layerId();
  _o.id = this.id();
  _o.playerId = this.playerId();
  _o.x = this.x();
  _o.y = this.y();
  _o.heading = this.heading();
  _o.hp = this.hp();
  _o.fuel = this.fuel();
  _o.vision = this.vision();
  _o.armor = this.armor();
  _o.mobility = this.mobility();
  _o.mtypeId = this.mtypeId();
  _o.builtThisTurn = this.builtThisTurn();
  _o.attackedThisTurn = this.attackedThisTurn();
  _o.waitedThisTurn = this.waitedThisTurn();
  _o.destroyed = this.destroyed();
  _o.annexed = this.annexed();
  _o.hasError = this.hasError();
  _o.cargo = this.bb!.createScalarList<number>(this.cargo.bind(this), this.cargoLength());
  _o.taxiId = this.taxiId();
  _o.weapons = this.bb!.createObjList<Weapon, WeaponT>(this.weapons.bind(this), this.weaponsLength());
  _o.floorE = this.floorE();
  _o.waterE = this.waterE();
  _o.road = this.road();
  _o.ap = this.ap();
  _o.apEntId = this.apEntId();
}
}

export class EntityT implements flatbuffers.IGeneratedObject {
constructor(
  public etypeId: EntityTypeId = EntityTypeId.Sea,
  public layerId: EntityLayerId = EntityLayerId.TerrainL1,
  public id: number = 0,
  public playerId: number = -1,
  public x: number = 0,
  public y: number = 0,
  public heading: number = 0,
  public hp: number = -1,
  public fuel: number = -1,
  public vision: number = -1,
  public armor: number = -1,
  public mobility: number = -1,
  public mtypeId: MoveTypeId = MoveTypeId.None,
  public builtThisTurn: boolean = false,
  public attackedThisTurn: boolean = false,
  public waitedThisTurn: boolean = false,
  public destroyed: boolean = false,
  public annexed: boolean = false,
  public hasError: boolean = false,
  public cargo: (number)[] = [],
  public taxiId: number = -1,
  public weapons: (WeaponT)[] = [],
  public floorE: number = -1,
  public waterE: number = -1,
  public road: RoadKind = RoadKind.None,
  public ap: number = -1,
  public apEntId: number = -1
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const cargo = Entity.createCargoVector(builder, this.cargo);
  const weapons = Entity.createWeaponsVector(builder, builder.createObjectOffsetList(this.weapons));

  return Entity.createEntity(builder,
    this.etypeId,
    this.layerId,
    this.id,
    this.playerId,
    this.x,
    this.y,
    this.heading,
    this.hp,
    this.fuel,
    this.vision,
    this.armor,
    this.mobility,
    this.mtypeId,
    this.builtThisTurn,
    this.attackedThisTurn,
    this.waitedThisTurn,
    this.destroyed,
    this.annexed,
    this.hasError,
    cargo,
    this.taxiId,
    weapons,
    this.floorE,
    this.waterE,
    this.road,
    this.ap,
    this.apEntId
  );
}
}
